

// import { Button, CircularProgress } from "@mui/material";
// import React, { useState } from "react";
// import { MdClose } from "react-icons/md";


// const MiniStatementPopup = ({ details, close, onSubmitAmount,loading }) => {
//   const [amount, setAmount] = useState("");

//   const [miniStatement,setMiniStatement] = useState([])

// const handleSubmit = () => {


//   const enteredAmount = Number(amount);
//   const availableAmount = Number(details?.balanceamount || 0);

//   if (!enteredAmount || enteredAmount <= 0) {
//     alert("Please enter a valid positive amount");
//     return;
//   }

//   if (enteredAmount > availableAmount) {
//     alert("Entered amount is greater than available balance");
//     return;
//   }

//   onSubmitAmount(enteredAmount); // ✅ only valid amount goes to parent
// };


//   return (
//     <div className="bg-white shadow-md border rounded-lg p-4 w-full max-w-sm">
//       <div className="flex justify-between items-center mb-3">
//         <h2 className="text-lg font-semibold">Balance Details</h2>
//         <MdClose className="cursor-pointer" onClick={close} />
//       </div>

//       <div className="space-y-2 text-sm">
//         <Row label="Message" value={details?.message} />
//         <Row label="Status" value={details?.status ? "SUCCESS" : "FAILED"} />
//         <Row label="Ack No" value={details?.ackno} />
//         <Row label="Bank RRN" value={details?.bankrrn} />
//         <Row label="Bank IIN" value={details?.bankiin} />
//         <Row label="Mobile" value={details?.mobile || "-"} />

//         <div className="flex justify-between border-t pt-2 mt-2">
//           <span className="font-semibold">Available Balance</span>
//           <span className="font-bold text-green-600">
//             ₹ {details?.balanceamount || "0.00"}
//           </span>
//         </div>
//       </div>

//       {/* 👇 Amount Input + Submit */}
//       <div className="flex gap-2 mt-4">
// <input
//   type="number"
//   placeholder="Enter Amount"
//   value={amount}
//   onChange={(e) => {
//     const val = e.target.value;

//     // empty allow (user delete kar sake)
//     if (val === "") {
//       setAmount("");
//       return;
//     }

//     const num = Number(val);
//     const available = Number(details?.balanceamount || 0);

//     // ❌ negative / zero
//     if (num <= 0) return;

//     // ❌ greater than available balance
//     if (num > available) return;

//     setAmount(val); // ✅ only valid value set
//   }}
//   min="1"
//   step="1"
//   className="border rounded px-2 py-1 w-full text-sm"
// />


//      <Button
//        onClick={handleSubmit}
//               type="submit"
//               fullWidth
//               variant="contained"
//               disabled={loading}
//               sx={{
//                 backgroundColor: "#",
//                 padding: "10px",
//                 borderRadius: "8px",
//               }}
//             >
//               {loading ? (
//                 <CircularProgress size={22} color="inherit" />
//               ) : (
//                 "Submit"
//               )}
//             </Button>


//         {/* <button
        
//           className="bg-blue-600 text-white px-4 rounded text-sm"
//         >
//           Submit
//         </button> */}
//       </div>
//     </div>
//   );
// };

// const Row = ({ label, value }) => (
//   <div className="flex justify-between">
//     <span>{label}</span>
//     <span className="font-medium">{value ?? "-"}</span>
//   </div>
// );

// export default MiniStatementPopup;



import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import { Button, CircularProgress } from "@mui/material";
import { formatAmount } from "../../../utils/formatAmount";
import { useNotify } from "../../../context/NotifyContext";

const MiniStatementPopup = ({ details, close, onSubmitAmount, loading }) => {
  const [amount, setAmount] = useState("");
  const { notify } = useNotify(); // ✅ use notify instead of alert

  const handleSubmit = () => {
    const enteredAmount = Number(amount);
    const availableAmount = Number(details?.balanceamount || 0);

    // ✅ Validation
    if (!enteredAmount || enteredAmount <= 0) {
      notify("Please enter a valid positive amount", "error");
      return;
    }

    if (enteredAmount > availableAmount) {
      notify("Entered amount is greater than available balance", "error");
      return;
    }

    onSubmitAmount(enteredAmount); // ✅ only valid amount goes to parent
  };


  return (
    <div className="bg-white dark:bg-slate-800 shadow-lg border rounded-lg p-4 w-full max-w-lg">
      {/* Header */}
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-lg font-semibold">Mini Statement</h2>
        <MdClose className="cursor-pointer text-xl" onClick={close} />
      </div>

      {/* Balance & Meta Info */}
      <div className="space-y-2 text-sm">
        <Row label="Status" value={details?.status ? "SUCCESS" : "FAILED"} />
        <Row label="Ack No" value={details?.ackno} />
        <Row label="Bank RRN" value={details?.bankrrn} />
        <Row label="Bank IIN" value={details?.bankiin} />
        <Row label="Date Time" value={details?.datetime} />

        <div className="flex justify-between border-t pt-2 mt-2">
          <span className="font-semibold">Available Balance</span>
          <span className="font-bold text-green-600">
            ₹ {formatAmount(details?.balanceamount) || "0.00"}
          </span>
        </div>
      </div>

      {/* Mini Statement Table */}
      <div className="mt-4">
        <h3 className="text-sm font-semibold mb-2">Last Transactions</h3>
        <MiniStatementTable data={details?.ministatement} />
      </div>

      {/* Amount Input + Submit */}
      <div className="flex gap-2 mt-4">
        <input
          type="number"
          placeholder="Enter Amount"
          value={amount}
          onChange={(e) => {
            const val = e.target.value;

            if (val === "") {
              setAmount("");
              return;
            }

            const num = Number(val);
            const available = Number(details?.balanceamount || 0);

            if (num <= 0) return;
            if (num > available) return;

            setAmount(val);
          }}
          min="1"
          step="1"
          className="border rounded px-2 py-1 w-full text-sm"
        />

        <Button
          onClick={handleSubmit}
          fullWidth
          variant="contained"
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={22} color="inherit" />
          ) : (
            "Submit"
          )}
        </Button>
      </div>
    </div>
  );
};

/* ---------------- TABLE ---------------- */

const MiniStatementTable = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-center text-sm text-gray-500 py-4">
        No mini statement available
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border border-gray-200 text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-3 py-2 border text-left">Date</th>
            <th className="px-3 py-2 border text-right">Amount</th>
            <th className="px-3 py-2 border text-center">Type</th>
            <th className="px-3 py-2 border text-left">Narration</th>
          </tr>
        </thead>
        <tbody>
          {data.map((txn, index) => (
        <tr
  key={`${txn.txnId || "txn"}-${txn.date || ""}-${index}`}
  className="border-t"
>

              <td className="px-3 py-2 border">{txn.date}</td>

              <td
                className={`px-3 py-2 border text-right font-semibold ${
                  txn.txnType === "C"
                    ? "text-green-600"
                    : "text-red-600"
                }`}
              >
                ₹ {formatAmount(txn.amount)}
              </td>

              <td className="px-3 py-2 border text-center">
                <span
                  className={`px-2 py-1 rounded text-xs font-medium ${
                    txn.txnType === "C"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }`}
                >
                  {txn.txnType === "C" ? "CREDIT" : "DEBIT"}
                </span>
              </td>

              <td className="px-3 py-2 border">
                {txn.narration || "-"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

/* ---------------- ROW ---------------- */

const Row = ({ label, value }) => (
  <div className="flex justify-between">
    <span>{label}</span>
    <span className="font-medium">{value ?? "-"}</span>
  </div>
);

export default MiniStatementPopup;
